import { useSetFilterConditionAtom } from '@/features/analyze/atoms/filterCondition.atom';
import {
  getFacetConditionValues,
  getPreferredFacetConditionOperator,
} from '@/features/analyze/lib/facetConditionUtils';
import { FacetKey } from '@/features/analyze/types';
import { useCallback } from 'react';

/**
 * 検索結果のタグクリック時にフィルター条件へ値を追加する共通フック
 * @returns addSearchResultTagFilter: (targetFieldKey, value) => void
 */
export const useSearchResultTagFilter = () => {
  const setFilterCondition = useSetFilterConditionAtom();

  /**
   * 指定したフィールドに値を追加する
   * @param targetFieldKey FacetKey
   * @param value 追加する値
   */
  const addSearchResultTagFilter = useCallback(
    (targetFieldKey: FacetKey, value: string) => {
      setFilterCondition((prev) => {
        const operator = getPreferredFacetConditionOperator(targetFieldKey);
        const prevTarget = getFacetConditionValues(
          targetFieldKey,
          operator,
          prev
        );

        if (prevTarget.includes(value)) return prev;

        return {
          ...prev,
          [targetFieldKey]: {
            ...prev[targetFieldKey],
            [operator]: [...prevTarget, value],
          },
        };
      });
    },
    [setFilterCondition]
  );

  return addSearchResultTagFilter;
};
